import { http } from '@/plugins/http';
import { getToken } from "@/util/util";

export default {
  //获取课程列表
  getCourseList (params) {
    return http({
      method: 'get',
      url: '/course/v2/course/course-lists',
      params: params
    })
  },
  getCourseType(params) {
    return http({
      method: 'get',
      url: '/course/v2/course/category',
      params: params
    })
  },
  getCourseDetail(params) {
    return http({
      method: 'get',
      url: '/vlabpassportapi/person/course-api/get-course-detail',
      params: params
    })
  },
  getHeaderFooter(params) {
    return http({
      method: 'get',
      url: '/cmsapi/v1/index-template/get-header-footer',
      params: params
    })
  },
  collectInfo(params) {
    return http({
      method: 'post',
      url: '/cmsapi/v1/collect-option/collect-option',
      data: params
    })
  },
  getUserInfo(params) {
    return http({
      method: 'get',
      url: '/userapi/v1/infosimple',
      params: params,
      headers: {
        Authorization: "bearer " + getToken(),
      }
    })
  },
  getMenu() {
    return http({
      method: 'get',
      url: '/cmsapi/v1/menus/get-login-menus',
      headers: {
        Authorization: "Bearer " + getToken(),
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/course/index.js